import React, { useEffect, useState } from "react";
import { COLUMNS } from './columns'
import Table from "../../common/Table/Table";
import AddUserButton from "../../common/AddUserButton/AddUserButton";
import Modal from "../../common/Modal/Modal";
import EmployeesForm from "../../forms/EmployeesForm/EmployeesForm";
import { PencilIcon, TrashIcon } from '@heroicons/react/outline'
import EmployeesService from "../../../services/EmployeesService";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const MySwal = withReactContent(Swal)

const Employees = () => {
    const [isOpen, setIsOpen] = useState(false)
    const [shouldLoad, setShouldLoad] = useState(true)
    const [userData, setUserData] = useState({})
    const [modalTitle, setModalTitle] = useState('')
    const [buttonText, setButtonText] = useState('Dodaj Zaposlenog')
    const [employeesData, setEmployeesData] = useState(null)


    useEffect(() => {
        if (shouldLoad) {
            setShouldLoad(false)
            getEmployees()
        }
    }, [shouldLoad])

    const getEmployees = () => {
        EmployeesService.getEmployees().then((response) => {
            setEmployeesData(response.data)
        });
    };

    const deleteEmployee = (id) => {
        MySwal.fire({
            showCancelButton: true,
            showDenyButton: true,
            showConfirmButton: false,
            denyButtonText: `Obriši`,
            cancelButtonText: `Otkaži`,
        }).then((result) => {
            if (result.isDenied) {
                EmployeesService.deleteEmployee(id).then(() => {
                    setShouldLoad(true)
                });
            }
        })
    };

    const addUser = (userData, formValues, idData) => {
        if (Object.keys(userData).length === 0) {
            EmployeesService.addEmployee(formValues).then(() => {
                setShouldLoad(true)
            });
        }
        else {
            formValues.id = idData
            EmployeesService.updateEmployee(formValues).then(() => {
                setShouldLoad(true)
            });
        }
    }

    const openModal = (row) => {
        setUserData(row.original);
        setIsOpen(true);
        setModalTitle('Izmeni zaposlenog');
    }

    const additionalColumn = {
        Header: ' ',
        Cell: ({ row }) => (
            <div className="flex items-center justify-end">
                <span className="p-2 rounded-full transition cursor-pointer purpleGradient" title="Obriši" onClick={() => deleteEmployee(row.original.id)}><TrashIcon className="w-4 h-4 text-white transition" /></span>
            </div>
        )
    }
    return (
        <>
            <AddUserButton setIsOpen={setIsOpen} setUserData={setUserData} setModalTitle={setModalTitle} buttonText={buttonText} />
            {isOpen &&
                <Modal setIsOpen={setIsOpen} modalContent={<EmployeesForm userData={userData} modalTitle={modalTitle} setIsOpen={setIsOpen} addUser={addUser} />} />
            }
            {employeesData !== null ?
                <Table columnsProp={COLUMNS} openModal={openModal} dataProp={employeesData} additionalColumn={additionalColumn} setIsOpen={setIsOpen} setUserData={setUserData} setModalTitle={setModalTitle} />
                : null}
        </>
    )

};

export default Employees;
